import axios from "axios";

export const subscriptionAPI = {
  
  getAllSubscriptions: async (params = {}) => {
    const response = await axios.get("/api/subscriptions", { params });
    return response.data;
  },

  getSubscriptionById: async (id) => {
    const response = await axios.get(`/api/subscriptions/${id}`);
    return response.data;
  },

  createSubscription: async (subscriptionData) => {
    const response = await axios.post("/api/subscriptions", subscriptionData);
    return response.data;
  },

  updateSubscriptionStatus: async (id, status, reason = "", metadata = null) => {
    const response = await axios.put(`/api/subscriptions/${id}/status`, {
      status,
      reason,
      metadata
    });
    return response.data;
  },

  processRenewal: async (id) => {
    const response = await axios.post(`/api/subscriptions/${id}/renewal`);
    return response.data;
  },

  getSubscriptionTransactions: async (id, params = {}) => {
    const response = await axios.get(`/api/subscriptions/${id}/transactions`, {
      params
    });
    return response.data;
  },

  getSubscriptionAnalytics: async (params = {}) => {
    const response = await axios.get("/api/subscriptions/analytics", { params });
    return response.data;
  },

  getUserSubscriptions: async (userId, params = {}) => {
    const response = await axios.get(`/api/subscriptions/user/${userId}`, { params });
    return response.data;
  },

  getSubscriptionGrowth: async (params = {}) => {
    const response = await axios.get("/api/subscriptions/growth", { params });
    return response.data;
  },

  getTopProductsBySubscriptions: async (limit = 5) => {
    const response = await axios.get("/api/subscriptions/top-products", { params: { limit } });
    return response.data;
  },
  
  getStatusDistribution: async () => {
    const response = await axios.get("/api/subscriptions/status-distribution");
    return response.data;
  },

  getRevenueTrends: async (params = {}) => {
    const response = await axios.get("/api/subscriptions/revenue-trends", { params });
    return response.data;
  }
};

export const transactionAPI = {
  
  getAllTransactions: async (params = {}) => {
    const response = await axios.get("/api/transactions", { params });
    return response.data;
  },

  getTransactionById: async (id) => {
    const response = await axios.get(`/api/transactions/${id}`);
    return response.data;
  },

  getTransactionStats: async (params = {}) => {
    const response = await axios.get("/api/transactions/stats", { params });
    return response.data;
  },

  createTransaction: async (transactionData) => {
    const response = await axios.post("/api/transactions", transactionData);
    return response.data;
  },

  updateTransactionStatus: async (id, status, reason = "") => {
    const response = await axios.put(`/api/transactions/${id}/status`, {
      status,
      reason
    });
    return response.data;
  },

  processRefund: async (id, amount = null, reason = "") => {
    const response = await axios.post(`/api/transactions/${id}/refund`, {
      amount,
      reason
    });
    return response.data;
  },

  generateReceipt: async (id) => {
    const response = await axios.get(`/api/transactions/${id}/receipt`);
    return response.data;
  },

  sendReceiptEmail: async (id) => {
    const response = await axios.post(`/api/transactions/${id}/receipt/email`);
    return response.data;
  },

  exportTransactions: async (params = {}) => {
    const response = await axios.get("/api/transactions/export", { 
      params,
      responseType: 'blob' 
    });
    return response.data;
  },

  getUserTransactions: async (userId, params = {}) => {
    const response = await axios.get(`/api/transactions/user/${userId}`, { params });
    return response.data;
  }
};

export const paymentAPI = {
  
  getAllPayments: async (params = {}) => {
    const response = await axios.get("/payments", { params });
    return response.data;
  },

  createPayment: async (paymentData) => {
    const response = await axios.post("/payments", paymentData);
    return response.data;
  }
};

export default {
  subscriptionAPI,
  paymentAPI
};